module.exports = __webpack_public_path__ + "images/feature/todo-tag-73ba038f5bbbfeb12c896eadb3e93f43.png";